module.exports = __webpack_public_path__ + "img/paso2019.02d996f3.gif";